module.exports = __webpack_public_path__ + "static/media/intro.c6d06771.md";